import { render, staticRenderFns } from "./SelfButtonGroup.vue?vue&type=template&id=027c25c2&"
import script from "./SelfButtonGroup.vue?vue&type=script&lang=js&"
export * from "./SelfButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./SelfButtonGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports